import { Chip } from '@mui/material';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const SEVERITY_COLOR = { critical: '#dc2626', high: '#ea580c', medium: '#d97706', low: '#2563eb', info: '#64748b' };
const STATUS_COLOR = { draft: '#64748b', published: '#16a34a', retired: '#991b1b' };
const pill = (text, color) => <Chip size="small" label={text} sx={{ bgcolor: `${color}1f`, color, fontWeight: 700 }} />;

const AdminThreatAlertsPage = () => {
  const columns = [
    { key: 'name', label: 'Alert' },
    { key: 'cve_id', label: 'CVE', render: (row) => row.cve_id || '-' },
    { key: 'severity', label: 'Severity', render: (row) => pill(String(row.severity).toUpperCase(), SEVERITY_COLOR[row.severity] || '#64748b') },
    { key: 'status', label: 'Status', render: (row) => pill(String(row.status).toUpperCase(), STATUS_COLOR[row.status] || '#64748b') },
    { key: 'check_ready', label: 'Check', render: (row) => (row.check_ready ? pill('Ready', '#16a34a') : pill(row.check_template_id ? 'Template missing or off' : 'None', '#d97706')) },
    { key: 'websites_checked', label: 'Websites checked' },
    { key: 'websites_vulnerable', label: 'Vulnerable', render: (row) => (row.websites_vulnerable ? pill(String(row.websites_vulnerable), '#dc2626') : '0') }
  ];
  const fields = [
    { name: 'name', label: 'Name clients will see', type: 'text', grid: 8 },
    { name: 'cve_id', label: 'CVE number (optional)', type: 'text', grid: 4 },
    { name: 'summary', label: 'What it is, in plain words', type: 'multiline', grid: 12 },
    { name: 'affected', label: 'Who is affected', type: 'multiline', grid: 6 },
    { name: 'fix', label: 'How to fix it', type: 'multiline', grid: 6 },
    { name: 'severity', label: 'Severity', type: 'select', grid: 4, defaultValue: 'critical', options: ['critical', 'high', 'medium', 'low'].map((v) => ({ value: v, label: v })) },
    { name: 'status', label: 'Status', type: 'select', grid: 4, defaultValue: 'draft', options: ['draft', 'published', 'retired'].map((v) => ({ value: v, label: v })) },
    { name: 'exploited_in_wild', label: 'Exploited in the wild', type: 'switch', grid: 4, defaultValue: true },
    { name: 'check_template_id', label: 'Check: Nuclei template id from your library (a check only looks, it never changes a website)', type: 'text', grid: 12 }
  ];
  return (
    <AdminResourceCrudPage
      title="Threat alerts"
      subtitle="Publish a flaw that is being exploited. Clients see it and can check their own websites with one click. Test a draft yourself on the Threat alerts page."
      icon={GppMaybeIcon}
      endpoint="/api/admin/threat-alerts/"
      columns={columns}
      fields={fields}
    />
  );
};

export default AdminThreatAlertsPage;
